var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-nav',{staticClass:"hidden-sm-and-up",attrs:{"value":true,"color":"grey","dark":"","fixed":""}},_vm._l((_vm.navigationItems),function(item){return _c('v-btn',{key:item.text,attrs:{"flat":"","to":{ path: item.route }}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(item.icon)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }